import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  removeLoginInfo,
  removeCurrentInfo,
} from "../../../../../features/mobile/commonSlice";
import { onResetQuestionComplete } from "../../../../../features/mobile/otherSlice";
import api from "../../../../../common/api";
// import Dialog from "../../../components/common/Dialog";
import HeadCont from "../../../components/common/HeadCont";
import Btn from "../../../components/common/Btn";
import OutSurvey from "../../../components/survey/OutSurvey";

const Resign = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginInfo } = useSelector((state) => state.commonApp);
  const [openDialog, setOpenDialog] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [surveyResponse, setSurveyResponse] = useState(null); // Withdrawal survey
  const [isLoading, setIsLoading] = useState(false); // Loading state for account deletion

  const unCheckedBox = useMemo(
    () => ({
      background:
        "url('/images/mobile/icon/checkbox_circle.svg') no-repeat center",
    }),
    []
  );
  const checkedBox = useMemo(
    () => ({
      background:
        "url('/images/mobile/icon/checkbox_circle_active.svg') no-repeat center",
    }),
    []
  );

  const onSurveyInput = (value) => {
    setSurveyResponse({
      selectedNum: value.selectedNum,
      selectedAnswer: value.selectedAnswer,
      etc: value.etc,
    });

    // Member withdrawal survey test
  };

  const onCheck = ({ target }) => setIsChecked(target.checked);

  const onResign = () => {
    let params = {
      userId: loginInfo.userId,
      withdrawalReason: surveyResponse.selectedAnswer,
      withdrawalEtcReason: surveyResponse.etc,
    };

    // Set loading state to true
    setIsLoading(true);

    //Member withdrawal
    api
      .post(`user/quit`, params)
      .then((res) => {
        if (res.data.ok === true) {
          navigate("/sign");
          dispatch(removeLoginInfo());
          dispatch(removeCurrentInfo());
          dispatch(onResetQuestionComplete());
        } else {
          // If deletion failed, reset loading state
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        // Reset loading state on error
        setIsLoading(false);
      });
  };

  return (
    <>
      <HeadCont title="Account Deletion Request" />
      <section className="px-4 pt-8 pb-20 mb-20 mt-14">
        {/* {openDialog && (
          <OutSurvey
            surveyResponse={surveyResponse}
            onSurveyInput={onSurveyInput}
            onClickEvent={onResign}
          />
        )} */}
        {openDialog ? (
          <OutSurvey
            openDialog={openDialog}
            surveyResponse={surveyResponse}
            onSurveyInput={onSurveyInput}
            title={"Before you leave Healiary, please tell us why you're deleting your account"}
            subTitle={
              "Your valuable feedback helps us improve our service. (Multiple selections allowed)"
            }
            // desc={"Are you sure you want to delete your account?"}
            leftBtnTitle={"Cancel"}
            rightBtnTitle={"Delete Account"}
            onLeftBtnAction={() => setOpenDialog(false)}
            onRightBtnAction={onResign}
            onCoverAction={() => setOpenDialog(false)}
            isLoading={isLoading}
          />
        ) : (
          <>
            <div className="keepAll text-caption2_400 text-gray_120 select-text">
              <h2 className="mb-4 text-body3_700 text-gray_160">
                Notice of Account Deletion and Data Anonymization
              </h2>

              <div className="mb-6">
                <p className="mb-2 font-semibold text-gray_160">When you delete your account:</p>
                <ul className="space-y-2 pl-4">
                  <li>• All personal information and service usage history will be irreversibly anonymized and can no longer be recovered or linked to you.</li>
                  <li>• Any personally identifiable data (such as name, phone number, or email address) will be permanently deleted.</li>
                  <li>• Certain non-identifiable data (e.g., disease type, dietary habits, meal and symptom records, weight, gender, date of birth) may be retained in encrypted and anonymized form for statistical, health management, and medical research purposes.</li>
                </ul>
              </div>

              <div className="mb-4">
                <p className="font-semibold text-gray_160">Please note:</p>
                <ul className="space-y-2 pl-4">
                  <li>• Once your account is deleted, it cannot be restored.</li>
                </ul>
              </div>
            </div>
            <div className="fixed bottom-[80px] left-0 flex w-full items-center justify-center gap-x-[8px] bg-gray_95 p-4">
              <input
                id="resignAgree"
                type="checkbox"
                onChange={(e) => onCheck(e)}
                checked={isChecked}
                style={isChecked ? checkedBox : unCheckedBox}
                className={
                  "mr-3 h-5 w-5 appearance-none rounded-full focus:border-gray_60 " +
                  (isChecked ? "text-gray_100" : "border border-gray_60")
                }
              />
              <label
                htmlFor="resignAgree"
                className="text-caption2_400 text-gray_160 select-text"
              >
                I understand that my account deletion is permanent and my data will be anonymized.
              </label>
            </div>
            <Btn
              option={"bottom"}
              bgColor={"bg-main"}
              textColor={"text-white fon-semibold"}
              borderColor={"border border-main"}
              title={"Delete Account"}
              active={isChecked ? "on" : "ready"}
              onAction={() => setOpenDialog(true)}
            />
          </>
        )}
        {/* {openDialog && (
          <Dialog
            innerClass={"p-4"}
            title={"Delete Account"}
            desc={"Are you sure you want to delete your account?"}
            leftBtnTitle={"No"}
            rightBtnTitle={"Yes"}
            onLeftBtnAction={() => setOpenDialog(false)}
            onRightBtnAction={onResign}
            onCoverAction={() => setOpenDialog(false)}
          />
        )} */}
      </section>
    </>
  );
};

export default Resign;
